import { render, staticRenderFns } from "./ComposedDiv.vue?vue&type=template&id=af6d713e"
import script from "./ComposedDiv.vue?vue&type=script&lang=js"
export * from "./ComposedDiv.vue?vue&type=script&lang=js"
import style0 from "./ComposedDiv.vue?vue&type=style&index=0&id=af6d713e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports